import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ReservationDeepLinkRedirect = () => {
  const { resyToken, bookOnBehalfOf } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (bookOnBehalfOf) {
      navigate(`/account/reservations-and-notify/${resyToken}/${bookOnBehalfOf}`);
    } else {
      navigate(`/account/reservations-and-notify/${resyToken}`);
    }
  }, []);

  return null;
};

ReservationDeepLinkRedirect.displayName = 'ReservationDeepLinkRedirect';
export default ReservationDeepLinkRedirect;
